module.exports = __webpack_public_path__ + "static/media/menu-dropdown-icon-home.bead3c60.svg";